module.exports = __webpack_public_path__ + "img/car_00040.e93621c6.jpg";